const SECOND_CBILS_DASHBOARD = 'page/SECOND_CBILS_DASHBOARD';
export const ACTIVATE_SECOND_CBILS_DASHBOARD = `${SECOND_CBILS_DASHBOARD} [activate]`;
export const LEAVE_SECOND_CBILS_DASHBOARD = `${SECOND_CBILS_DASHBOARD} [leaving]`;
export const SECOND_CBILS_DASHBOARD_READY = `${SECOND_CBILS_DASHBOARD}_READY`;
